module.exports = __webpack_public_path__ + "static/media/video.e3ddca4d.mp4";